<template>
  <div class="trial-balance">
    <div class="section operations" style="margin-bottom:1px;">
      <el-form inline style="margin-bottom:-8px;">
        <!--会计期间-->
        <el-form-item label="Accounting Interval">
          <el-select ref="fromFPRef" v-model="form.fromFP" style="width: 120px;" placeholder="Please select">
            <el-option
              v-for="(item,index) in fiscalPeriods"
              :key="index"
              :label="fiscalPeriodLabelFun(item)"
              :value="item.uuid"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="-">
          <el-select v-model="form.toFP" style="width: 120px;" placeholder="Please select">
            <el-option
              v-for="(item,index) in fiscalPeriods"
              :key="index"
              :label="fiscalPeriodLabelFun(item)"
              :value="item.uuid"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <!--查询-->
          <el-button class="el-margin" type="primary" @click="doSearch">Search</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="section" style="flex: 1;padding: 0px;">
      <cargo-ag-grid
        :show-side-bar="false"
        :column-defs="columnDefs"
        :grid-options="gridOptions"
        :grid-params.sync="girdParams"
        :auto-fit-content="false"
        :row-data="rowData"
        style="height: 800px;"
      />
    </div>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import * as statementDescriptionApi from '@/api/financeManage/statementDescription'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import * as NumberUtils from '@/utils/NumberUtils'
import { exportExcelMultiHeader } from '@/utils/tableDataExportUtils'
import { ABC_US } from '@/utils/StrUtils'
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'TrialBalance',
  components: { cargoAdvanceSelect },
  props: {
    accountSet: { type: Object, default: null },
    statementDescription: { type: Object, default: null }
  },
  data() {
    return {
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          sortable: false // 去掉每列的排序
        },
        suppressContextMenu: false,
        getContextMenuItems: () => {
          const self = this
          return [
            {
              name: 'Export excel',
              action: function() {
                self.exportExcelHandler()
              }
            }
          ]
        }
      },
      rowData: [],
      selectTypeNames: TYPE_NAMES,
      form: {
        fromFP: '',
        toFP: ''
      }
    }
  },
  computed: {
    // 当前会计期间
    currentFiscalPeriod() {
      return this.accountSet ? this.accountSet.currentFiscalPeriod : null
    },
    // 初始会计期间
    initialFiscalPeriod() {
      return this.accountSet ? this.accountSet.initialFiscalPeriod : null
    },
    // 会计期间
    fiscalPeriods() {
      return this.accountSet ? this.accountSet.fiscalPeriod : []
    },
    fiscalPeriod() {
      if (this.fiscalPeriods && this.form.fromFP) {
        return this.fiscalPeriods.find(fp => fp.uuid === this.form.fromFP)
      }
      return null
    },
    columnDefs() {
      return [
        { headerName: 'Company', field: 'company', width: 100,
          cellStyle: { textAlign: 'center' }
        },
        { headerName: 'Account', field: 'accountTitle', width: 120,
          cellRenderer: params => {
            return ColumnUtils.accountNoLabelItemRenderer(params.value)
          }
        },
        { headerName: 'Description', field: 'accountTitleName', width: 200 },
        { headerName: 'Type', field: 'type', width: 80,
          cellStyle: { textAlign: 'center' }
        },
        { headerName: 'Br', field: 'br', width: 80,
          cellStyle: { textAlign: 'center' }
        },
        { headerName: 'Direction', field: 'direction', width: 120,
          cellStyle: { textAlign: 'center' }
        },
        { headerName: 'Mode', field: 'mode', width: 100,
          cellStyle: { textAlign: 'center' }
        },
        { headerName: 'Year', field: 'year', width: 100,
          cellStyle: { textAlign: 'center' }
        },
        { headerName: 'Period', field: 'period', width: 100,
          cellStyle: { textAlign: 'center' }
        },
        { headerName: 'Amount in Period', field: 'amount', width: 150,
          cellStyle: { textAlign: 'right' },
          cellRenderer: params => {
            return this.amountLabelItemRenderer(params.value)
          }
        },
        { headerName: 'Currency', field: 'currency', width: 90,
          cellStyle: { textAlign: 'center' }
        }
      ]
    },
    excelColumnDefs() {
      return [
        { headerName: 'Company', field: 'company', width: 100, hide: false },
        { headerName: 'Account', field: 'accountTitle', width: 120,
          cellRenderer: params => { return ColumnUtils.accountNoLabelItemRenderer(params.value) + ' ' },
          hide: false
        },
        { headerName: 'Description', field: 'accountTitleName', width: 200, hide: false },
        { headerName: 'Type', field: 'type', width: 80, hide: false },
        { headerName: 'Br', field: 'br', width: 80, hide: false },
        { headerName: 'Direction', field: 'direction', width: 120, hide: false },
        { headerName: 'Mode', field: 'mode', width: 100, hide: false },
        { headerName: 'Year', field: 'year', width: 100, hide: false },
        { headerName: 'Period', field: 'period', width: 100, hide: false },
        {
          headerName: 'Amount in Period', field: 'amount', width: 150,
          cellRenderer: params => { return params.value ? params.value : '' },
          hide: false
        },
        { headerName: 'Currency', field: 'currency', width: 90, hide: false }
      ]
    },
    elementFormulaEditable() {
      if (!this.currentFiscalPeriod || !this.initialFiscalPeriod) {
        return false
      }
      if (this.currentFiscalPeriod.year === this.initialFiscalPeriod.year &&
        this.currentFiscalPeriod.month === this.initialFiscalPeriod.month) {
        return true
      }
      if (this.currentFiscalPeriod.year !== this.initialFiscalPeriod.year && this.currentFiscalPeriod.month === 1) {
        return true
      }
      return false
    },
    fromFP() {
      if (this.fiscalPeriods && this.form.fromFP) {
        return this.fiscalPeriods.find(fp => fp.uuid === this.form.fromFP)
      }
      return null
    },
    toFP() {
      if (this.fiscalPeriods && this.form.toFP) {
        return this.fiscalPeriods.find(fp => fp.uuid === this.form.toFP)
      }
      return null
    }
  },
  watch: {
    accountSet(newVal) {
      if (newVal) {
      }
    }
  },
  beforeMount() {

  },
  methods: {
    fiscalPeriodLabelFun(data) {
      if (data) {
        return data.year + '.' + data.month
      }
      return ''
    },
    doSearch() {
      const params = {}
      params.accountSetKey = this.accountSet.uuid
      params.statementName = this.statementDescription.statementName
      params.statementDescriptionUuid = this.statementDescription.uuid
      const fromFP = this.fromFP
      const toFP = this.toFP
      if (fromFP) {
        params.month = fromFP.month
        params.year = fromFP.year
      }
      if (toFP) {
        params.endMonth = toFP.month
        params.year = toFP.year
      }
      // 相同年
      if (fromFP && fromFP.year && toFP && toFP.year && fromFP.year !== toFP.year) {
        this.$refs.fromFPRef.focus()
        this.$message.warning(this.$t('CargoMsg.Cargo_PSFPOTSY'), this.$t('CargoMsg.Cargo_Tips'))
        return
      }
      this.rowData = []
      const loading = getLoading()
      statementDescriptionApi.getStatement2UsaReport(params).then(resp => {
        this.getStatementResult(resp)
      }).finally(() => loading.close())
    },
    getStatementResult(resp) {
      const result = resp.data
      if (result && result.dataProvider) {
        this.rowData = result.dataProvider
      }
    },
    amountLabelItemRenderer(value) {
      if (value) {
        return NumberUtils.formatRoundNumber(value, 2)
      }
      return ''
    },
    exportExcelHandler() {
      const columnDefs = []
      this.excelColumnDefs.forEach(column => { if (!column.hide) columnDefs.push({ colDef: column }) })
      let exportFileName = 'Trial Balance - List of Movements Account, Period, Branch and Department to '
      if (this.toFP) {
        exportFileName = exportFileName + this.toFP.year + this.toFP.month
      }
      const multiHeader = []
      const row = []
      columnDefs.forEach(column => { row.push('') })
      row[0] = this.$store.getters.currentOffice.englishName
      multiHeader.push(row)
      const row1 = row.concat()
      row1[0] = 'Trial Balance - List of Movements Account, Period, Branch and Department'
      multiHeader.push(row1)
      const row2 = row.concat()
      row2[0] = 'Period From:' + this.fromFP.year + this.fromFP.month + ' To: ' + this.toFP.year + this.toFP.month
      multiHeader.push(row2)
      const row3 = row.concat()
      row3[0] = 'Printed by ' + this.$store.getters.userInfo.englishName + ' ' + this.$moment(new Date()).format('D-MMM-YY HH:mm:ss A')
      multiHeader.push(row3)
      const col = columnDefs.length
      const colName = ABC_US[col - 1]
      const merges = ['A1:' + colName + '1', 'A2:' + colName + '2', 'A3:' + colName + '3', 'A4:' + colName + '4']
      exportExcelMultiHeader(multiHeader, merges, exportFileName, this.rowData, columnDefs)
    },
    defaultFpUuid() {
      if (this.form.fromFP) return
      if (this.fiscalPeriods) {
        this.form.fromFP = this.fiscalPeriods[0].uuid
        this.form.toFP = this.fiscalPeriods[0].uuid
      }
    }
  }
}
</script>

<style scoped>

</style>
